import { useEffect, useState } from "react";

import useAxios from "../../services/useAxios.tsx";
import Swal from "sweetalert2";
import AuthenticationContext from "context/Authentication/AuthenticationContext.ts";
import { useContext } from "react";
import CustomButton from "../kits/custom-button/CustomButton.tsx";

export default function LogInNumber({
  ChangeModal,
  loginkey,
  SetNumber,
  number,
  setLoginShow,
}) {
  const { loading: loadingSendCode, execute: loginApi } = useAxios("api/login");
  const [code, setcode] = useState("");
  const auth = useContext(AuthenticationContext);
  let SetCode = (e) => {
    if (!isNaN(e.target.value)) {
      setcode(e.target.value);
    }
  };
  // const {
  //   shoppingData,
  //   updateCartItem,
  //   cartItem,
  //   isLoading,
  //   setIsLoading,
  //   setCountUpdater,
  // } = useContext(CartItemsContext);

  useEffect(() => {
    (() => {
      "use strict";

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.querySelectorAll(".needs-validation");
      // Loop over them and prevent submission
      Array.prototype.slice.call(forms).forEach((form) => {
        form.addEventListener(
          "submit",
          (event) => {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }
            event.preventDefault();
            form.classList.add("was-validated");
          },
          false
        );
      });
    })();
  }, []);

  let SendCode = () => {
    // sendRequest("login", { mobile: number, hashcode: loginkey, code }).then(
    // loginApi({ mobile: number, hashcode: loginkey, code }).then(({ data }) => {
    loginApi({ mobile: number, hashcode: loginkey, code }).then((data) => {
      if (data.status == 1) {
        let userType;
        // if (data.userinfo[0].isadmin == 1) {
        //   switch (+data.userinfo[0].user_admin_group) {
        //     case 1:
        //       userType = USER_TYPE.generalAdmin;
        //       break;
        //     case 2:
        //       userType = USER_TYPE.tourLeader;
        //       break;
        //     case 3:
        //       userType = USER_TYPE.accountants;
        //       break;
        //     case 4:
        //       userType = USER_TYPE.saleCounter;

        //     default:
        //       break;
        //   }
        // } else {
        //   userType = USER_TYPE.customer;
        // }
        auth.login(
          data.data.usertoken,
          data.userinfo[0].fname + " " + data.userinfo[0].lname,
          data.userinfo[0].fname,
          data.userinfo[0].lname,
          +data.userinfo[0].type,
          data.userinfo[0].mobile,
          "",
          [],
          +data.userinfo[0].id
        );

        Swal.fire({
          title: "خوش آمدید",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });
        // window.location.reload();
        setLoginShow(false);
        ChangeModal(0);
        // updateCartItem();
      } else if (data.status == 0) {
        Swal.fire({
          title: "خطا!",
          text: "لطفا دوباره امتحان کنید",
          type: "error",
          confirmButtonText: "باشه",
        });
      } else {
        Swal.fire({
          title: "خطا!",
          text: "شما مجاز نیستید",
          type: "error",
          confirmButtonText: "باشه",
        });
      }
    });
  };
  return (
    <form className="needs-validation" noValidate onSubmit={SendCode}>
      <div className="modal-body text-center">
        {/* <img
          // src={logo}
          src={logoName}
          width="200px"
          className="my-4"
          alt=""
          style={{
            backgroundColor: "rgb(220 53 69)",
            padding: "5px",
            borderRadius: "7px",
          }}
        /> */}
        {/* <div className="d-flex "> */}
        {/* <h5>ورود یا ثبت نام در فروشگاه </h5> */}{" "}
        {/* shFazeli 1402/04/31 end */}
        {/* <img src={logo} style={{ width: "70px", height: "60px" }} /> */}
        {/* </div> */}
        <label htmlFor="number" className="mb-4 my-3 text-muted">
          {/* برای ورود به فروشگاه کد دریافتی را وارد کنید */}{" "}
          {/* shFazeli 1402/04/31 end */}
          کد دریافتی را وارد کنید
        </label>
        <input
          onChange={SetCode}
          value={code}
          // type="number"
          style={{
            height: "50px",
            borderRadius: "15px",
            direction: "ltr",
            // fontFamily: "digits", {/* shFazeli 1402/04/31 end */}
            marginBottom: "15px",
            textAlign: "center",
            fontFamily: "inherit", // shFazeli 1402/04/31 end
          }}
          id="number"
          placeholder="کد دریافتی"
          className="form-control w-75 mx-auto"
          required
        />
        <div
          className="invalid-feedback"
        // style={{ marginRight: "63px" }}
        >
          لطفا کد دریافتی را وارد کنید
        </div>
        {/* <label
          htmlFor="number"
          className="d-block my-3"
          style={{ color: "#1D3354" }}
        >
          کد دریافتی را وارد کنید
        </label> */}
        <CustomButton
          type="submit"
          state={loadingSendCode ? "loading" : "default"}
          className="btn my-3 w-75 pd-y-8 he-50 text-white mx-auto"
          style={{ backgroundColor: "#7C3AED" }}
        >
          ارسال
        </CustomButton>
      </div>
    </form>
  );
}
